/**
 * $t('enum.E_ErrorCodes.AccountExpired')
 * $t('enum.E_ErrorCodes.SensorNotExisted')
 */
export enum E_ErrorCodes {
    /**
     * 账号到期
     */
    AccountExpired = 1037,

    /**
     * 传感器不存在
     */
    SensorNotExisted = 1024,
}
